import * as io from 'io-ts';

export const string = io.string;
export const nullableString = io.union([io.string, io.null]);
